/**
 * Rappresenta un cittadino, autenticato tramite SPID
 */
export interface ICitizen {
  id: number;
  /** Codice univoco (SPID) */
  spidCode: string;
  name: string;
  familyName: string;
  fullName: string; // Calcolato
  placeOfBirth?: string;
  placeOfBirthCode?: string; // codice luogo di nascita
  countyOfBirth?: string;
  dateOfBirth?: string; // YYYY-MM-DD
  gender?: string;

  fiscalNumber: string;
  localFiscalNumber?: string;
  ivaCode?: string;
  companyName?: string;
  registeredOffice?: string;

  mobilePhone?: string;
  email?: string;
  address: string;

  nationality?: CitizenNationality;
  country?: string | null;

  idCard?: string;

  digitalAddress?: string;
  expirationDate?: string;

  /** Informazioni domicilio */
  domicileStreetAddress?: string; // Domicilio (via, viale, piazza)
  domicilePostalCode?: string; // Codice Postale
  domicileMunicipality?: string; // Comune
  domicileProvince?: string; // Provincia
  domicileNation?: string; //Nazione
}

export enum CitizenNationality {
  Italy = 'Italy',
  /** Nazioni UE che supportano il login con eIDAS */
  EU = 'EU',
  /** Altri paesi del mondo (non eIDAS) */
  ExtraEU = 'ExtraEU'
}
